export const frontEnd = [
    {
        name: "CSS",
        photo: "https://img.icons8.com/color/64/css3.png"
    },
    {
        name: "HTML",
        photo: "https://img.icons8.com/color/64/html-5--v1.png"
    },
    {
        name: "JavaScript",
        photo: "https://img.icons8.com/color/64/javascript--v1.png"
    },
    {
        name: "React",
        photo: "https://cdn-icons-png.flaticon.com/64/1126/1126012.png"
    }
]

export const miscellaneous = [
    {
        name: "Firebase",
        photo: "https://img.icons8.com/color/64/firebase.png"
    },
    {
        name: "Npm",
        photo: "https://img.icons8.com/color/64/npm.png"
    },
    {
        name: "Webpack",
        photo: "https://img.icons8.com/color/64/webpack.png"
    },
    {
        name: "Github",
        photo: "https://img.icons8.com/ios-glyphs/64/github.png"
    },
    {
        name: "Git",
        photo: "https://img.icons8.com/color/64/git.png"
    }
]